module.exports = __webpack_public_path__ + "static/img/noData1.871f4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noData1.png
// module id = WhN0
// module chunks = 4